const ITEMS = [
    "Toriano Sanzone",
    "Consciousness of Abundance",
    "Human Creativity × Artificial Intelligence",
    "Webinar & eBook Access",
    "$19.99 Only",
];

export const Marquee = () => (
    <div data-testid="editorial-marquee" className="relative border-y border-orchid/30 bg-gradient-to-r from-[#120A24] via-[#22114A] to-[#120A24] py-5 overflow-hidden select-none">
        <div className="flex w-max animate-marquee">
            {[0, 1].map((dup) => (
                <div key={dup} className="flex shrink-0 items-center" aria-hidden={dup === 1}>
                    {ITEMS.concat(ITEMS).map((item, i) => (
                        <span key={`${dup}-${i}`} className="flex items-center">
                            <span className="font-serif italic text-lg sm:text-xl text-gold/80 px-6 whitespace-nowrap">{item}</span>
                            <span className="text-gold/40 text-xs">◆</span>
                        </span>
                    ))}
                </div>
            ))}
        </div>
    </div>
);
